export class UserDetailDM {
  constructor({
    pk = 0,
    email = "",
    phone_number = "",
    organization_name = "",
    department_name = "",
    using_default_password = false,
    profile_pic_url = "",
    first_name = "",
    last_name = "",
    nik = "",
    has_kriya_permission = false,
    is_redemption = false,
    is_superuser = false,
    is_staff = false,
    point_allocation = false,
    organization_slug = "",
    office_phone_number = "",
    address = "",
    martial_status = "",
    date_of_birth = "",
    gender = 0,
    membership = "",
    member_card = "",
    membership_num = "",
    membership_qrkey = "",
    expiry_date = "",
    is_private = false,
    facebook = "",
    twitter = "",
    linkedin = "",
    company_name = "",
    job_title = "",
    short_bio = "",
    company_profile = "",
    website = "",
    is_admin_organization_group = false,
    division_name = "",
    area_name = "",
    has_organization_group = false,
    age = 0,
    gender_name = "",
    is_trial = false,
    grade = "",
    age_range = "",
    tenure = "",
    organization = 8,
    has_member_group_request = true,
    points = 0,
    stars = 0,
    appreciations = [],
    date_employed = "",
    point_expiry_date = "",
  }) {
    this.pk = pk;
    this.email = email;
    this.phone_number = phone_number;
    this.organization_name = organization_name;
    this.department_name = department_name;
    this.using_default_password = using_default_password;
    this.profile_pic_url = profile_pic_url;
    this.first_name = first_name;
    this.last_name = last_name;
    this.nik = nik;
    this.has_kriya_permission = has_kriya_permission;
    this.is_redemption = is_redemption;
    this.is_superuser = is_superuser;
    this.is_staff = is_staff;
    this.point_allocation = point_allocation;
    this.organization_slug = organization_slug;
    this.office_phone_number = office_phone_number;
    this.address = address;
    this.martial_status = martial_status;
    this.date_of_birth = date_of_birth;
    this.gender = gender;
    this.membership = membership;
    this.member_card = member_card;
    this.membership_num = membership_num;
    this.membership_qrkey = membership_qrkey;
    this.expiry_date = expiry_date;
    this.is_private = is_private;
    this.facebook = facebook;
    this.twitter = twitter;
    this.linkedin = linkedin;
    this.company_name = company_name;
    this.job_title = job_title;
    this.short_bio = short_bio;
    this.company_profile = company_profile;
    this.website = website;
    this.is_admin_organization_group = is_admin_organization_group;
    this.division_name = division_name;
    this.area_name = area_name;
    this.has_organization_group = has_organization_group;
    this.age = age;
    this.gender_name = gender_name;
    this.is_trial = is_trial;
    this.grade = grade;
    this.age_range = age_range;
    this.tenure = tenure;
    this.organization = organization;
    this.has_member_group_request = has_member_group_request;
    this.points = points;
    this.stars = stars;
    this.appreciations = appreciations;
    this.date_employed = date_employed;
    this.point_expiry_date = point_expiry_date;
  }

  static fromJson(json) {
    return new UserDetailDM({
      pk: json["pk"],
      email: json["email"],
      phone_number: json["phone_number"],
      organization_name: json["organization_name"],
      department_name: json["department_name"],
      using_default_password: json["using_default_password"],
      profile_pic_url: json["profile_pic_url"],
      first_name: json["first_name"],
      last_name: json["last_name"],
      nik: json["nik"],
      has_kriya_permission: json["has_kriya_permission"],
      is_redemption: json["is_redemption"],
      is_superuser: json["is_superuser"],
      is_staff: json["is_staff"],
      point_allocation: json["point_allocation"],
      organization_slug: json["organization_slug"],
      office_phone_number: json["office_phone_number"],
      address: json["address"],
      martial_status: json["martial_status"],
      date_of_birth: json["date_of_birth"],
      gender: json["gender"],
      membership: json["membership"],
      member_card: json["member_card"],
      membership_num: json["membership_num"],
      membership_qrkey: json["membership_qrkey"],
      expiry_date: json["expiry_date"],
      is_private: json["is_private"],
      facebook: json["facebook"],
      twitter: json["twitter"],
      linkedin: json["linkedin"],
      company_name: json["company_name"],
      job_title: json["job_title"],
      short_bio: json["short_bio"],
      company_profile: json["company_profile"],
      website: json["website"],
      is_admin_organization_group: json["is_admin_organization_group"],
      division_name: json["division_name"],
      area_name: json["area_name"],
      has_organization_group: json["has_organization_group"],
      age: json["age"],
      gender_name: json["gender_name"],
      is_trial: json["is_trial"],
      grade: json["grade"],
      age_range: json["age_range"],
      tenure: json["tenure"],
      organization: json["organization"],
      has_member_group_request: json["has_member_group_request"],
      points: json["points"],
      stars: json["stars"],
      date_employed: json["date_employed"],
      appreciations: json["appreciations"],
      point_expiry_date: json["point_expiry_date"],
    });
  }

  toMapEditProfile() {
    return {
      first_name: this.first_name ? this.first_name : "",
      last_name: this.last_name ? this.last_name : "",
      nik: this.nik ? this.nik : "",
      email: this.email ? this.email : "",
      job_title: this.job_title ? this.job_title : "",
      address: this.address ? this.address : "",
      short_bio: this.short_bio ? this.short_bio : "",
      organization_name: this.organization_name ? this.organization_name : "",
      department_name: this.department_name ? this.department_name : "",
      division_name: this.division_name ? this.division_name : "",
      area_name: this.area_name ? this.area_name : "",
      phone_number: this.phone_number ? this.phone_number : "",
      date_of_birth: this.date_of_birth ? this.date_of_birth : "",
      martial_status: this.martial_status ? this.martial_status : "",
      gender: this.gender ? this.gender : "",
      facebook: this.facebook ? this.facebook : "",
      twitter: this.twitter ? this.twitter : "",
      linkedin: this.linkedin ? this.linkedin : "",
      website: this.website ? this.website : "",
    };
  }
}
